import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function adminInviteUsersAPI(users) {
  const url = `${AWS_API_URL}/admin/users/invite`;
  return postRequest(url, mapDataForBackend(users), await authorize());
}
